import React, {useEffect, useState} from 'react';
import Feather from 'react-native-vector-icons/Feather';
import CCText from '../CCText';
import Box from '../Box';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import Ionicons from 'react-native-vector-icons/Ionicons';
import Spacer from '../Spacer';
import {MaterialCommunityIcons} from '@expo/vector-icons';
import {
  Image,
  Pressable,
  View,
  TouchableOpacity,
  Linking,
  StyleSheet,
} from 'react-native';
import {RFPercentage} from 'react-native-responsive-fontsize';

const SwitchToAppBanner = ({handleSwitchToAppBannerClose}) => {
  const [platformOS, setPlatformOS] = useState<
    'iOS' | 'Android' | 'Other' | null
  >(null);
  // Add this line
  const getMobileOS = (): 'iOS' | 'Android' | 'Other' => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      // Optional: guard against MS Stream (rare legacy IE scenario)
      const isNotWindows = !(
        typeof window !== 'undefined' && 'MSStream' in window
      );
      if (isNotWindows) {
        return 'iOS';
      }
    }

    return 'Other';
  };
  useEffect(() => {
    setPlatformOS(getMobileOS());
  }, []);
  return (
    <Box type="row-center" style={styles.wrapper}>
      <Box onPress={() => handleSwitchToAppBannerClose?.()} style={styles.container}>
        <Image
          source={require('@/Assets/Images/Svgs/download.svg')}
          style={{width: 20, height: 20}}
        />
      </Box>
      <Box flex={1} style={styles.text}>
        <CCText
          textAlign="center"
          color={CCColors.White}
          fontSize={RFPercentage(2)}
          fontWeight="bold">
          Go to the app for the best experience.
        </CCText>
      </Box>

      <Box flexDirection="row" gap={5}>
        {platformOS === 'iOS' && (
          <Box
            onPress={() =>
              Linking.openURL(
                'https://apps.apple.com/in/app/circlechess-live-tournaments/id6743388978',
              )
            }
            type="row-center"
            hitSlop={{
              top: 40,
              bottom: 40,
              left: 40,
              right: 40,
            }}
            style={styles.icon}>
            <MaterialCommunityIcons
              name="apple"
              size={20}
              color={CCColors.Black}
            />
          </Box>
        )}
        {platformOS === 'Android' && (
          <Box
            onPress={() =>
              Linking.openURL(
                'https://play.google.com/store/apps/details?id=com.circlechess.cc_learning',
              )
            }
            type="row-center"
            style={styles.image}>
            <Image
              source={require('@/Assets/Images/Svgs/playstore.svg')}
              style={{width: 15, height: 15}}
            />
          </Box>
        )}
        {platformOS === 'Other' && (
          <>
            <Box
              onPress={() =>
                Linking.openURL(
                  'https://apps.apple.com/in/app/circlechess-live-tournaments/id6743388978',
                )
              }
              type="row-center"
              hitSlop={{
                top: 40,
                bottom: 40,
                left: 40,
                right: 40,
              }}
              style={styles.iconwrapper}>
              <MaterialCommunityIcons
                name="apple"
                size={20}
                color={CCColors.Black}
              />
            </Box>
            <Box
              onPress={() =>
                Linking.openURL(
                  'https://play.google.com/store/apps/details?id=com.circlechess.cc_learning',
                )
              }
              type="row-center"
              style={styles.imagewraper}>
              <Image
                source={require('@/Assets/Images/Svgs/playstore.svg')}
                style={{width: 15, height: 15}}
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: CCColors.TextColor.Dark,
    paddingHorizontal: 10,
    paddingVertical: 9,
  },
  container: {
    backgroundColor: CCColors.White,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
  },
  text: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingHorizontal: 1,
  },
  icon: {
    backgroundColor: CCColors.Primary.Default,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
  },
  image: {
    backgroundColor: CCColors.Primary.Default,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
  },
  iconwrapper: {
    backgroundColor: CCColors.Primary.Default,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
  },
  imagewraper: {
    backgroundColor: CCColors.Primary.Default,
    borderRadius: 15,
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
  },
});

export default SwitchToAppBanner;
